import { mask } from 'remask';

export function unmaskPhoneNumber(value: string) {
  const phone = ['9999999999', '99999999999'];

  return mask(value, phone);
}
